import { render, staticRenderFns } from "./my_switch.vue?vue&type=template&id=67b6bcbf&scoped=true&"
import script from "./my_switch.vue?vue&type=script&lang=js&"
export * from "./my_switch.vue?vue&type=script&lang=js&"
import style0 from "./my_switch.vue?vue&type=style&index=0&id=67b6bcbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6bcbf",
  null
  
)

export default component.exports